<template>
    <div id="container" v-show="this.$store.state.showContainer">
        <tab />
        <div class="question">
            <p>{{questionData.correctMean}}</p>
            <ul>
                <li v-for="( item, index) in questionData.options" :key="index" @click="selectAnswer(index)" ref="questionIndex">
                    {{item}}
                    <div class="add_num" ref="addNum">+&nbsp;{{addNum}}</div>
                    <div class="sub_num" ref="subNum">-&nbsp;{{subNum}}</div>
                    <div ref="righticon" class="righticon"></div>
                </li>
                <li ref="notknows" @click="notKnow">我不认识</li>
            </ul>
        </div>
        <div class="footer">
            <span>测试20个单词即可查看结果</span>
        </div>
        <div id="submit" v-if="showSubmit">
            <div class="mask"></div>
            <div class="container">
                <p>恭喜你完成测试！本次测得词汇量为{{this.$store.state.lastVocabulary}}</p>
                <div class="show_result" @click="showResult" data-rlog="view_result">现在查看</div>
                <div class="cancel" @click="reset">再测一次</div>
            </div>
        </div>
        <div class="first_wrong" v-if="isFirstWrong">
            <div class="mask"></div>
            <div class="container">
                <p>题目答错会加倍扣分，不确定的词点击【不认识】会让测试结果更准确</p>
                <div class="show_result" @click="knowRules">知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { setShare } from './../libs/libs.js'
    import { getVocabulary, saveWordExamResult, recommendBook } from './../libs/sever.js'
    import { mapGetters } from 'vuex'
    import Tab from './Tab';
    export default {
        name: 'Container',
        data () {
            return {
                notViewResults: 'http://shared.youdao.com/dict/market/recite-vocabulary/img/page1_button1.png',
                canViewResults: 'http://shared.youdao.com/dict/market/recite-vocabulary/img/page1_button.png',
                rightVideo: 'http://shared.youdao.com/dict/market/recite-vocabulary/img/right_sound.mp3',
                worongVideo: 'http://shared.youdao.com/dict/market/recite-vocabulary/img/wrong_sound.mp3',
                questionData: '',
                choiceState: true, // true 是可点击状态。false，不可点击状态
                firstChiose: true,
                showResultButten: true,
                booksList: '',
                addNum: '',
                subNum: '',
                showSubmit: false,
                toast: false,
                isFirstWrong: false
            }
        },
        mounted () {
            this.init()
        },
        computed:{
            ...mapGetters([
                'wrongAnswer',
                'allQuestions'
            ])
        },
        watch: {
            wrongAnswer: function (val) {
                if (val === 1) {
                    this.isFirstWrong = true
                }
            },
            allQuestions: function (val) {
                if (val === 20) {
                    this.showSubmit = true
                }
            }  
        },
        methods: {
            init: function () {
                let that = this
                getVocabulary(this.$store.state.start, this.$store.state.end).then(function (res) {
                    that.questionData = res.data.data.result.wordExam
                    that.$store.commit('RECORDRIGHTINDEX', res.data.data.result.wordExam.correctIndex)
                    that.$store.commit('VOCABULARY', that.questionData.correctRank)
                })
            },
            getRightAnswer: function (index) {
                let that = this
                // let audio = new Audio();
                // audio.src = this.rightVideo
                // audio.play();
                this.$store.commit('RESERNMAX')
                let target = this.$refs.questionIndex[index]
                target.setAttribute("class", "question_right")
                this.addNum = this.$store.state.vocabulary - this.$store.state.lastVocabulary
                this.$refs.righticon[index].style.display = 'block'
                this.$refs.addNum[index].style.display = 'inline-block'
                this.$refs.addNum[index].setAttribute("class", "animate add_num")
                this.resetStart(true)
                that.$store.commit('WRONGINDEX')
                that.$store.commit('LASTVOCABULARY')
                that.$store.commit('RIGHTANSWER')
                setTimeout((e) => {
                    target.setAttribute("class", "")
                    that.$refs.righticon.forEach((item, index) => {
                        item.style.display = 'none'
                    })
                    that.$refs.addNum[index].style.display = 'none'
                    that.$refs.addNum[index].setAttribute("class", "add_num")
                    that.choiceState = true
                    that.init()
                }, 1000);
            },
            getWrongAnswer: function (index) {
                let target
                let that = this
                target = this.$refs.questionIndex[index]
                target.setAttribute("class", "question_wrong shake")
                let targetRight = this.$refs.questionIndex[this.questionData.correctIndex]
                that.$store.commit('WRONGINDEX', true)
                if (this.$store.state.wrongIndex > 2) {
                    this.$store.commit('RESERNMAX', true)
                }
                let str = Math.floor(Math.random() * (this.$store.state.Nmax) + this.$store.state.Nmax / 2)
                that.$store.commit('VOCABULARY', Math.ceil(parseInt(this.$store.state.lastVocabulary) - str))
                that.$store.commit('LASTVOCABULARY')
                that.$store.commit('WRONGANSWER')
                this.subNum = this.$store.state.motionNum - this.$store.state.lastVocabulary
                this.$refs.righticon[this.questionData.correctIndex].style.display = 'block'
                if ( that.$store.state.allQuestions > 19 ) {
                    that.showResultButten = true
                }
                this.$refs.subNum[index].style.display = 'inline-block'
                this.$refs.subNum[index].setAttribute("class", "animate sub_num")
                targetRight.setAttribute("class", "question_right")
                if ( that.$store.state.allQuestions > 19 ) {
                    that.showResultButten = true
                }
                this.resetStart(false)
                setTimeout((e) => {
                    targetRight.setAttribute("class", "")
                    target.setAttribute("class", "")
                    that.init()
                    that.$refs.righticon.forEach((item, index) => {
                        item.style.display = 'none'
                    })
                    that.$refs.subNum[index].style.display = 'none'
                    that.$refs.subNum[index].setAttribute("class", "sub_num")
                    that.choiceState = true
                }, 1000);
            },
            notKnow: function () {
                if (!this.choiceState) {
                    return
                }
                this.choiceState = false
                let that = this
                let target
                target = this.$refs.notknows
                this.$store.commit('NOKNOW')
                target.setAttribute("class", "question_wrong")
                let targetRight = this.$refs.questionIndex[this.questionData.correctIndex]
                targetRight.setAttribute("class", "question_right")
                this.$refs.righticon[this.questionData.correctIndex].style.display = 'block'
                if ( that.$store.state.allQuestions > 19 ) {
                    that.showResultButten = true
                }
                setTimeout((e) => {
                    target.setAttribute("class", "")
                    that.init()
                    targetRight.setAttribute("class", "")
                    that.$refs.righticon.forEach((item, index) => {
                        item.style.display = 'none'
                    })
                    that.choiceState = true
                }, 1000);
            },
            resetStart: function (chiose) {
                if (chiose) {
                    this.$store.commit('RESERSTART', (parseInt(this.questionData.correctRank) + parseInt(this.$store.state.Nmax)))
                    this.$store.commit('RESEREND', (parseInt(this.questionData.correctRank) + parseInt(this.$store.state.Nmax * 2)))
                } else {
                    this.$store.commit('RESERSTART', (parseInt(this.$store.state.lastVocabulary) + parseInt(this.$store.state.Nmax)))
                    this.$store.commit('RESEREND', (parseInt(this.$store.state.lastVocabulary) + parseInt(this.$store.state.Nmax * 2)))
                }
            },
            showResult: function () {
                let that = this
                let str = `不吹不黑，我的词汇量达到${this.$store.state.lastVocabulary}`
                setShare(str, true)
                recommendBook(this.$store.state.lastVocabulary).then(function (res) {
                    that.$store.commit('BOOKLIST', res.data.data.result.recommendBooks)
                })
                window.ydk.isLogin({
                    success: function (res) {
                        if (res.isLogin) {
                            saveWordExamResult(that.$store.state.lastVocabulary)
                        }
                    }
                })
                this.$store.commit('HIDECONTAINER')
            },
            selectAnswer: function (index) {
                if (!this.choiceState) {
                    return
                }
                this.choiceState = false
                if (this.$store.state.allQuestions == 19 || this.$store.state.allQuestions > 19 ) {
                    this.showResultButten = true
                }
                if (index == this.$store.state.rightIndex) {
                    this.getRightAnswer(index)
                } else {
                    this.getWrongAnswer(index)
                }
            },
            reset: function () {
                location.reload()
            },
            knowRules: function () {
                this.isFirstWrong = false
            }
        },
        components: {
            Tab
        }
    }
</script>

<style>
    @font-face { 
        font-family: DINAlternateBold; /*这里是说明调用来的字体名字*/ 
        src: url(http://shared.youdao.com/dict/market/recite-vocabulary/fonts/DINAlternateBold.ttf); /*这里是字体文件路径*/ 
    }
    #container {
        width: 100%;
        overflow: hidden;
    }
    #container p {
        width: 6.5rem;
        font-size: 0.53rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.68rem;
        text-align: center;
        margin: 0.53rem auto 0.53rem;
    }
    #container li {
        width: 6.5rem;
        height: 0.92rem;
        background: rgba(251,252,253,1);
        border-radius: 0.1rem;
        border: 0.01rem solid rgba(233,231,233,1);
        margin: 0 auto 0.3rem;
        font-size: 0.32rem;
        font-family:PingFangSC-Regular;
        color:rgba(68,81,103,1);
        line-height: 0.92rem;
        text-align: center;
        position: relative;
    }
    #container span {
        width: 100%;
        text-align: center;
        display: block;
        font-size: 0.26rem;
        font-family:PingFangSC-Regular;
        color:rgba(144,148,158,1);
        line-height: 0.26rem;
        margin: 0.8rem 0 0.34rem 0;
    }
    #container .butten {
        width: 3.72rem;
        height: 0.89rem;
        margin: 0 auto 0.4rem;
    }
    #container .show_result {
        width: 3.72rem;
        height: 0.89rem;
        margin: 0 auto 0.4rem;
        background: linear-gradient(135.4deg,rgba(255,175,36,1),rgba(255,138,38,1),rgba(255,135,38,1),rgba(255,135,38,1));
        border-radius: 1rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium;
        color: rgba(255,255,255,1);
        line-height: 0.89rem;
        text-align: center;
    }
    #container ul .question_right {
        border: 1px solid rgba(72,219,145,1);
    }
    #container ul .question_wrong {
        border: 1px solid rgba(245,176,62,1);
    }
    .righticon {
        position: absolute;
        bottom: -0.01rem;
        right: -0.01rem;
        width: 0.45rem;
        height: 0.45rem;
        background-image: url(http://shared.youdao.com/dict/market/recite-vocabulary/imgs/img_correct_green_normal.png);
        border-radius: 0.1rem;
        background-size: 100% 100%;
        background-color: #000;
        display: none;
    }
    #container .footer {
        height: 16%;
    }
    .add_num, .sub_num {
        display: none;
        position: absolute;
        right: 0.5rem;
        height: 0.92rem;
        line-height: 0.92rem;
        font-size: 0.44rem;
        font-family: PingFangSC-Regular;
        font-family: DINAlternateBold;
        margin: 0;
    }
    .add_num {
        color: rgba(72,219,145,1);
    }
    .sub_num {
        color: rgba(245,176,62,1);
    }
    .animate {
        animation: mymove 5s infinite;
        -webkit-animation: mymove 2s infinite; /* Safari 和 Chrome */
    }
    @keyframes mymove
    {
        from {
            top: 0;
            opacity: 1;
        }
        to {
            top: -1rem;
            opacity: 0;
        }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/
    {
        from {
            top: 0;
            opacity: 1;
        }
        to {
            top: -1rem;
            opacity: 0;
        }
    }
    .shake{
        -webkit-animation-name: shake_box;
        -ms-animation-name: shake_box;
        animation-name: shake_box;
        -webkit-animation-duration: 100ms;
        -ms-animation-duration: 100ms;
        animation-duration: 100ms;
        -webkit-animation-timing-function: ease-in-out;
        -ms-animation-timing-function: ease-in-out;
        animation-timing-function: ease-in-out;
        -webkit-animation-delay: 0s;
        -ms-animation-delay: 0s;
        animation-delay: 0s;
        /*-webkit-animation-play-state: running;
        -ms-animation-play-state: running;
        animation-play-state: running;*/
    }
    @keyframes shake_box{
        0% {transform: translate(0px, 0px) rotate(0deg)}
        20% {transform: translate(1.5px, -2.5px) rotate(-1.5deg)}
        40% {transform: translate(-2.5px, 0.5px) rotate(-0.5deg)}
    }
    @-ms-keyframes shake_box{
        0% {-ms-transform: translate(0px, 0px) rotate(0deg)}
        20% {-ms-transform: translate(1.5px, -2.5px) rotate(-1.5deg)}
        40% {transform: translate(-2.5px, 0.5px) rotate(-0.5deg)}
    }

    #submit, .first_wrong {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    #submit .mask, #container .first_wrong .mask{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000;
        opacity: 0.5;
    }
    #submit .container{
        width: 6.7rem;
        height: 4.2rem;
        position: fixed;
        top: 3.32rem;
        left: 50%;
        margin-left: -3.35rem;
        background: rgba(255,255,255,1);
        border-radius: 6px;
        border: 1px solid rgba(225,225,225,1);
    }
    #container .first_wrong .container{
        width: 6.7rem;
        overflow: hidden;
        position: fixed;
        top: 3.32rem;
        left: 50%;
        margin-left: -3.35rem;
        background: rgba(255,255,255,1);
        border-radius: 6px;
        border: 1px solid rgba(225,225,225,1);
    }
    #submit p, #container .first_wrong p{
        width: 5.3rem;
        height: 0.8rem;
        margin: 0.52rem auto 0.59rem;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.48rem;
    }
    #submit .show_result, #container .first_wrong .show_result{
        width: 5.50rem;
        height: 0.9rem;
        background: linear-gradient(135.4deg,rgba(255,175,36,1),rgba(255,138,38,1),rgba(255,135,38,1),rgba(255,135,38,1));
        box-shadow: 0px 4px 11px 0px rgba(254,187,97,0.36);
        border-radius: 1rem;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        color: rgba(255,255,255,1);
        line-height: 0.9rem;
        margin: 0 auto 0.4rem;
    }
    #submit .cancel, #container .first_wrong .cancel{
        width: 100%;
        text-align: center;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        color: rgba(144,148,158,1);
        line-height: 0.32rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Container.vue